import { Permissions } from '../../core/enums/permissions.enum'
import { LayersDefinition } from '../models/layers-definition.model'

export const Layers: LayersDefinition = {
  RoadSegment: {
    name: 'rs',
    permissions: [Permissions.RCS_RoadSegments_All_Read, Permissions.RCS_RoadSegments_Rc_Read],
  },
  WeatherPrediction: {
    name: 'wp',
    permissions: [Permissions.RCS_Weather_All_Read],
  },
  VAWarning: {
    name: 'vaw',
    permissions: [Permissions.RCS_Warnings_Va_Read, Permissions.RCS_Warnings_All_Read],
  },
  BDVWarning: {
    name: 'bdvw',
    permissions: [Permissions.RCS_Warnings_Bdv_Read, Permissions.RCS_Warnings_All_Read],
  },
  TLWarning: {
    name: 'tlw',
    permissions: [Permissions.RCS_Warnings_Tl_Read, Permissions.RCS_Warnings_All_Read],
  },
  CSWarning: {
    name: 'csw',
    permissions: [Permissions.RCS_Warnings_Cs_Read, Permissions.RCS_Warnings_All_Read],
  },
  LVWarning: {
    name: 'lvw-area',
    permissions: [Permissions.RCS_Warnings_Lv_Read, Permissions.RCS_Warnings_All_Read],
  },
  HRWarning: {
    name: 'hrw-area',
    permissions: [Permissions.RCS_Warnings_Hr_Read, Permissions.RCS_Warnings_All_Read],
  },
  HSWarning: {
    name: 'hsw-area',
    permissions: [Permissions.RCS_Warnings_Hs_Read, Permissions.RCS_Warnings_All_Read],
  },
  SWWarning: {
    name: 'sww-area',
    permissions: [Permissions.RCS_Warnings_Sw_Read, Permissions.RCS_Warnings_All_Read],
  },
  PRWarning: {
    name: 'prw-area',
    permissions: [Permissions.RCS_Warnings_Pr_Read, Permissions.RCS_Warnings_All_Read],
  },
  WWDWarning: {
    name: 'wwdw-area',
    permissions: [Permissions.RCS_Warnings_Wwd_Read, Permissions.RCS_Warnings_All_Read],
  },
  IORWarning: {
    name: 'iorw-area',
    permissions: [Permissions.RCS_Warnings_Ior_Read, Permissions.RCS_Warnings_All_Read],
  },
  ALWarning: {
    name: 'alw-area',
    permissions: [Permissions.RCS_Warnings_Al_Read, Permissions.RCS_Warnings_All_Read],
  },
  BLWarning: {
    name: 'blw-area',
    permissions: [Permissions.RCS_Warnings_Bl_Read, Permissions.RCS_Warnings_All_Read],
  },
  SVWarning: {
    name: 'svw-area',
    permissions: [Permissions.RCS_Warnings_Sv_Read, Permissions.RCS_Warnings_All_Read],
  },
  TJTWarning: {
    name: 'tjtw-area',
    permissions: [Permissions.RCS_Warnings_Tjt_Read, Permissions.RCS_Warnings_All_Read],
  },
  SimWarning: {
    name: 'simw',
    permissions: [Permissions.RCS_Apps_Simulation_Access, Permissions.RCS_Apps_All],
  },
  SimEditorLayer: {
    name: 'sime',
    permissions: [Permissions.RCS_Apps_Simulation_Access, Permissions.RCS_Apps_All],
  },

  CreateSimAreaWarnings: {
    name: 'csaw',
    permissions: [
      Permissions.RCS_Warnings_All_Read,
      Permissions.RCS_Warnings_Lv_Write,
      Permissions.RCS_Warnings_Sw_Write,
      Permissions.RCS_Warnings_Hr_Write,
      Permissions.RCS_Warnings_Hs_Write,
    ],
  },
  CreateSimRoadWarnings: {
    name: 'csrw',
    permissions: [
      Permissions.RCS_Warnings_All_Read,
      Permissions.RCS_Warnings_Va_Write,
      Permissions.RCS_Warnings_Tl_Write,
      Permissions.RCS_Warnings_Bdv_Write,
      Permissions.RCS_Warnings_Cs_Write,
      Permissions.RCS_Warnings_Pr_Write,
      Permissions.RCS_Warnings_Wwd_Write,
      Permissions.RCS_Warnings_Ior_Write,
      Permissions.RCS_Warnings_Al_Write,
      Permissions.RCS_Warnings_Bl_Write,
      Permissions.RCS_Warnings_Sv_Write,
      Permissions.RCS_Warnings_Tjt_Write,
    ],
  },
  Provider1Accidents: {
    name: 'p1va',
    permissions: [Permissions.RCS_Hazards_All_Read],
  },
  Provider1ConstructionSites: {
    name: 'p1cs',
    permissions: [Permissions.RCS_Hazards_All_Read],
  },
  Provider1Bdv: {
    name: 'p1bdv',
    permissions: [Permissions.RCS_Hazards_All_Read],
  },
  Provider2Accidents: {
    name: 'p2va',
    permissions: [Permissions.RCS_Hazards_All_Read],
  },
  Provider2ConstructionSites: {
    name: 'p2cs',
    permissions: [Permissions.RCS_Hazards_All_Read],
  },
  Provider2Bdv: {
    name: 'p2bdv',
    permissions: [Permissions.RCS_Hazards_All_Read],
  },
  Provider3Accidents: {
    name: 'p3va',
    permissions: [Permissions.RCS_Hazards_All_Read],
  },
  Provider3ConstructionSites: {
    name: 'p3cs',
    permissions: [Permissions.RCS_Hazards_All_Read],
  },
  Provider3Bdv: {
    name: 'p3bdv',
    permissions: [Permissions.RCS_Hazards_All_Read],
  },
  Provider4HeavyRain: {
    name: 'p4hr',
    permissions: [Permissions.RCS_Hazards_All_Read],
  },
  Provider4Fog: {
    name: 'p4f',
    permissions: [Permissions.RCS_Hazards_All_Read],
  },
  Provider4Slippery: {
    name: 'p4s',
    permissions: [Permissions.RCS_Hazards_All_Read],
  },
  Provider4Bdv: {
    name: 'p4bdv',
    permissions: [Permissions.RCS_Hazards_All_Read],
  },
  Provider4Accidents: {
    name: 'p4va',
    permissions: [Permissions.RCS_Hazards_All_Read],
  },
  Provider6Accidents: {
    name: 'p6va',
    permissions: [Permissions.RCS_Hazards_All_Read],
  },
  Provider6Bdv: {
    name: 'p6bdv',
    permissions: [Permissions.RCS_Hazards_All_Read],
  },
  Provider7Accidents: {
    name: 'p7va',
    permissions: [Permissions.RCS_Hazards_All_Read],
  },
  Provider7Bdv: {
    name: 'p7bdv',
    permissions: [Permissions.RCS_Hazards_All_Read],
  },
  Provider8Accidents: {
    name: 'p8va',
    permissions: [Permissions.RCS_Hazards_All_Read],
  },
  Provider8Bdv: {
    name: 'p8bdv',
    permissions: [Permissions.RCS_Hazards_All_Read],
  },
  Provider8Wdw: {
    name: 'p8wdw',
    permissions: [Permissions.RCS_Hazards_All_Read],
  },
  Provider8Cs: {
    name: 'p8cs',
    permissions: [Permissions.RCS_Hazards_All_Read],
  },
  Provider8Sv: {
    name: 'p8sv',
    permissions: [Permissions.RCS_Hazards_All_Read],
  },
  Provider9Cs: {
    name: 'p9cs',
    permissions: [Permissions.RCS_Hazards_All_Read],
  },
  Provider9Sv: {
    name: 'p9sv',
    permissions: [Permissions.RCS_Hazards_All_Read],
  },
  Webcams: { name: 'wc', permissions: [] },
}
